import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ConnectPage } from './routes/ConnectPage';
import { SessionPage } from './routes/SessionPage';
import { NotFound } from './routes/NotFound';
import { LoginPage } from './routes/LoginPage';
import { SignupPage } from './routes/SignupPage';
import { MachinesPage } from './routes/MachinesPage';
import { SecurityPage } from './routes/SecurityPage';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { useAuthStore } from './auth/store';

export function App() {
  // Validate the persisted JWT on first mount. If the server has revoked the user (or the token
  // expired), `hydrate()` wipes the session before any UI tries to use it.
  const hydrate = useAuthStore((s) => s.hydrate);
  useEffect(() => {
    hydrate();
  }, [hydrate]);

  return (
    <Routes>
      <Route path="/" element={<ConnectPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route
        path="/machines"
        element={
          <ProtectedRoute>
            <MachinesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/security"
        element={
          <ProtectedRoute>
            <SecurityPage />
          </ProtectedRoute>
        }
      />
      <Route path="/session/:hostId" element={<SessionPage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
